import React, { useState } from "react";
import { Box, Typography, Collapse, IconButton } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { Add, Remove } from "@mui/icons-material";

// Import logo
import logo from "./assets/logo.png";

const Footer = () => {
  const navigate = useNavigate();

  // State for collapsible sections in mobile view
  const [expandedSections, setExpandedSections] = useState({
    shopCategories: false,
    popularBrands: false,
    company: false,
  });

  const handleNavigation = (path) => {
    navigate(path);
  };

  const toggleSection = (section) => {
    setExpandedSections((prev) => ({
      ...prev,
      [section]: !prev[section],
    }));
  };

  return (
    <Box
      sx={{
        backgroundColor: "#f5f5f5",
        borderTop: "4px solid #EF5658",
        pt: 5,
        pb: 3,
        px: "100px",
        "@media (max-width: 1360px)": {
          px: "16px",
        },
      }}
    >
      <Box
        sx={{
          display: "flex",
          gap: 4,
          mb: 3,
          "@media (max-width: 1360px) and (min-width: 857px)": {
            flexDirection: "column",
            gap: 3,
          },
          "@media (max-width: 856px)": {
            flexDirection: "column",
            gap: 3,
          },
        }}
      >
        {/* Desktop: All 4 columns in one row | Tablet: First row with 2 columns | Mobile: Single column */}
        <Box
          sx={{
            display: "flex",
            gap: 4,
            "@media (max-width: 1360px) and (min-width: 857px)": {
              justifyContent: "space-between",
            },
            "@media (max-width: 856px)": {
              flexDirection: "column",
              gap: 1,
            },
          }}
        >
          {/* Shop Categories */}
          <Box
            sx={{
              flex: "1 1 25%",
              minWidth: 0,
              "@media (max-width: 856px)": {
                width: "100%",
                mb: 2,
              },
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                cursor: "pointer",
                "@media (min-width: 857px)": {
                  cursor: "default",
                },
              }}
              onClick={() => toggleSection("shopCategories")}
            >
              <Typography
                sx={{
                  fontSize: "16px",
                  fontWeight: "bold",
                  color: "#333",
                  mb: 1,
                  textTransform: "uppercase",
                  "@media (max-width: 856px)": {
                    mb: 0,
                  },
                }}
              >
                SHOP CATEGORIES
              </Typography>
              <IconButton
                sx={{
                  display: "none",
                  "@media (max-width: 856px)": {
                    display: "flex",
                    alignItems: "center",
                    p: 0,
                    minWidth: "auto",
                    height: "auto",
                  },
                  "&:hover": {
                    backgroundColor: "transparent",
                  },
                }}
                disableRipple
              >
                {expandedSections.shopCategories ? <Remove /> : <Add />}
              </IconButton>
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 1,
                "@media (max-width: 856px)": {
                  display: "none",
                },
              }}
            >
              <Typography
                sx={{
                  fontSize: "14px",
                  color: "#666",
                  cursor: "pointer",
                  "&:hover": { color: "#EF5658" },
                }}
              >
                Action Figures
              </Typography>
              <Typography
                sx={{
                  fontSize: "14px",
                  color: "#666",
                  cursor: "pointer",
                  "&:hover": { color: "#EF5658" },
                }}
              >
                Dolls & Dollhouses
              </Typography>
              <Typography
                sx={{
                  fontSize: "14px",
                  color: "#666",
                  cursor: "pointer",
                  "&:hover": { color: "#EF5658" },
                }}
              >
                Building & Construction Toys
              </Typography>
              <Typography
                sx={{
                  fontSize: "14px",
                  color: "#666",
                  cursor: "pointer",
                  "&:hover": { color: "#EF5658" },
                }}
              >
                Educational & Learning Toys
              </Typography>
              <Typography
                sx={{
                  fontSize: "14px",
                  color: "#666",
                  cursor: "pointer",
                  "&:hover": { color: "#EF5658" },
                }}
              >
                Vehicles & Remote-Control Toys
              </Typography>
              <Typography
                sx={{
                  fontSize: "14px",
                  color: "#666",
                  cursor: "pointer",
                  "&:hover": { color: "#EF5658" },
                }}
              >
                Outdoor & Sports Toys
              </Typography>
              <Typography
                sx={{
                  fontSize: "14px",
                  color: "#666",
                  cursor: "pointer",
                  "&:hover": { color: "#EF5658" },
                }}
              >
                Arts & Crafts
              </Typography>
            </Box>
            <Collapse
              in={expandedSections.shopCategories}
              sx={{
                display: "none",
                "@media (max-width: 856px)": {
                  display: "block",
                },
              }}
            >
              <Box
                sx={{ display: "flex", flexDirection: "column", gap: 1, pt: 1 }}
              >
                <Typography
                  sx={{
                    fontSize: "14px",
                    color: "#666",
                    cursor: "pointer",
                    "&:hover": { color: "#EF5658" },
                  }}
                >
                  Action Figures
                </Typography>
                <Typography
                  sx={{
                    fontSize: "14px",
                    color: "#666",
                    cursor: "pointer",
                    "&:hover": { color: "#EF5658" },
                  }}
                >
                  Dolls & Dollhouses
                </Typography>
                <Typography
                  sx={{
                    fontSize: "14px",
                    color: "#666",
                    cursor: "pointer",
                    "&:hover": { color: "#EF5658" },
                  }}
                >
                  Building & Construction Toys
                </Typography>
                <Typography
                  sx={{
                    fontSize: "14px",
                    color: "#666",
                    cursor: "pointer",
                    "&:hover": { color: "#EF5658" },
                  }}
                >
                  Educational & Learning Toys
                </Typography>
                <Typography
                  sx={{
                    fontSize: "14px",
                    color: "#666",
                    cursor: "pointer",
                    "&:hover": { color: "#EF5658" },
                  }}
                >
                  Vehicles & Remote-Control Toys
                </Typography>
                <Typography
                  sx={{
                    fontSize: "14px",
                    color: "#666",
                    cursor: "pointer",
                    "&:hover": { color: "#EF5658" },
                  }}
                >
                  Outdoor & Sports Toys
                </Typography>
                <Typography
                  sx={{
                    fontSize: "14px",
                    color: "#666",
                    cursor: "pointer",
                    "&:hover": { color: "#EF5658" },
                  }}
                >
                  Arts & Crafts
                </Typography>
              </Box>
            </Collapse>
          </Box>

          {/* Popular Brands */}
          <Box
            sx={{
              flex: "1 1 25%",
              minWidth: 0,
              "@media (max-width: 856px)": {
                width: "100%",
                mb: 2,
              },
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                cursor: "pointer",
                "@media (min-width: 857px)": {
                  cursor: "default",
                },
              }}
              onClick={() => toggleSection("popularBrands")}
            >
              <Typography
                sx={{
                  fontSize: "16px",
                  fontWeight: "bold",
                  color: "#333",
                  mb: 1,
                  textTransform: "uppercase",
                  "@media (max-width: 856px)": {
                    mb: 0,
                  },
                }}
              >
                POPULAR BRANDS
              </Typography>
              <IconButton
                sx={{
                  display: "none",
                  "@media (max-width: 856px)": {
                    display: "flex",
                    alignItems: "center",
                    p: 0,
                    minWidth: "auto",
                    height: "auto",
                  },
                  "&:hover": {
                    backgroundColor: "transparent",
                  },
                }}
                disableRipple
              >
                {expandedSections.popularBrands ? <Remove /> : <Add />}
              </IconButton>
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 1,
                "@media (max-width: 856px)": {
                  display: "none",
                },
              }}
            >
              <Typography
                sx={{
                  fontSize: "14px",
                  color: "#666",
                  cursor: "pointer",
                  "&:hover": { color: "#EF5658" },
                }}
              >
                Hasbro
              </Typography>
              <Typography
                sx={{
                  fontSize: "14px",
                  color: "#666",
                  cursor: "pointer",
                  "&:hover": { color: "#EF5658" },
                }}
              >
                Mattel
              </Typography>
              <Typography
                sx={{
                  fontSize: "14px",
                  color: "#666",
                  cursor: "pointer",
                  "&:hover": { color: "#EF5658" },
                }}
              >
                LEGO
              </Typography>
              <Typography
                sx={{
                  fontSize: "14px",
                  color: "#666",
                  cursor: "pointer",
                  "&:hover": { color: "#EF5658" },
                }}
              >
                Melissa & Doug
              </Typography>
              <Typography
                sx={{
                  fontSize: "14px",
                  color: "#666",
                  cursor: "pointer",
                  "&:hover": { color: "#EF5658" },
                }}
              >
                Funko
              </Typography>
              <Typography
                sx={{
                  fontSize: "14px",
                  color: "#666",
                  cursor: "pointer",
                  "&:hover": { color: "#EF5658" },
                }}
              >
                Green Toys
              </Typography>
              <Typography
                sx={{
                  fontSize: "14px",
                  color: "#666",
                  cursor: "pointer",
                  "&:hover": { color: "#EF5658" },
                }}
              >
                Basic Fun!
              </Typography>
            </Box>
            <Collapse
              in={expandedSections.popularBrands}
              sx={{
                display: "none",
                "@media (max-width: 856px)": {
                  display: "block",
                },
              }}
            >
              <Box
                sx={{ display: "flex", flexDirection: "column", gap: 1, pt: 1 }}
              >
                <Typography
                  sx={{
                    fontSize: "14px",
                    color: "#666",
                    cursor: "pointer",
                    "&:hover": { color: "#EF5658" },
                  }}
                >
                  Hasbro
                </Typography>
                <Typography
                  sx={{
                    fontSize: "14px",
                    color: "#666",
                    cursor: "pointer",
                    "&:hover": { color: "#EF5658" },
                  }}
                >
                  Mattel
                </Typography>
                <Typography
                  sx={{
                    fontSize: "14px",
                    color: "#666",
                    cursor: "pointer",
                    "&:hover": { color: "#EF5658" },
                  }}
                >
                  LEGO
                </Typography>
                <Typography
                  sx={{
                    fontSize: "14px",
                    color: "#666",
                    cursor: "pointer",
                    "&:hover": { color: "#EF5658" },
                  }}
                >
                  Melissa & Doug
                </Typography>
                <Typography
                  sx={{
                    fontSize: "14px",
                    color: "#666",
                    cursor: "pointer",
                    "&:hover": { color: "#EF5658" },
                  }}
                >
                  Funko
                </Typography>
                <Typography
                  sx={{
                    fontSize: "14px",
                    color: "#666",
                    cursor: "pointer",
                    "&:hover": { color: "#EF5658" },
                  }}
                >
                  Green Toys
                </Typography>
                <Typography
                  sx={{
                    fontSize: "14px",
                    color: "#666",
                    cursor: "pointer",
                    "&:hover": { color: "#EF5658" },
                  }}
                >
                  Basic Fun!
                </Typography>
              </Box>
            </Collapse>
          </Box>
          {/* Company */}
          <Box
            sx={{
              flex: "1 1 25%",
              minWidth: 0,
              "@media (max-width: 1360px) and (min-width: 857px)": {
                display: "none",
              },
              "@media (max-width: 856px)": {
                width: "100%",
                mb: 2,
              },
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                cursor: "pointer",
                "@media (min-width: 857px)": {
                  cursor: "default",
                },
              }}
              onClick={() => toggleSection("company")}
            >
              <Typography
                sx={{
                  fontSize: "16px",
                  fontWeight: "bold",
                  color: "#333",
                  mb: 1,
                  textTransform: "uppercase",
                  "@media (max-width: 856px)": {
                    mb: 0,
                  },
                }}
              >
                COMPANY
              </Typography>
              <IconButton
                sx={{
                  display: "none",
                  "@media (max-width: 856px)": {
                    display: "flex",
                    alignItems: "center",
                    p: 0,
                    minWidth: "auto",
                    height: "auto",
                  },
                  "&:hover": {
                    backgroundColor: "transparent",
                  },
                }}
                disableRipple
              >
                {expandedSections.company ? <Remove /> : <Add />}
              </IconButton>
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 1,
                "@media (max-width: 856px)": {
                  display: "none",
                },
              }}
            >
              <Typography
                sx={{
                  fontSize: "14px",
                  color: "#666",
                  cursor: "pointer",
                  "&:hover": { color: "#EF5658" },
                }}
                onClick={() => handleNavigation("/about")}
              >
                About Us
              </Typography>
              <Typography
                sx={{
                  fontSize: "14px",
                  color: "#666",
                  cursor: "pointer",
                  "&:hover": { color: "#EF5658" },
                }}
                onClick={() => handleNavigation("/how-r3play-works")}
              >
                How R3PLAY Works
              </Typography>
              <Typography
                sx={{
                  fontSize: "14px",
                  color: "#666",
                  cursor: "pointer",
                  "&:hover": { color: "#EF5658" },
                }}
                onClick={() => handleNavigation("/contact")}
              >
                Contact Us
              </Typography>
            </Box>
            <Collapse
              in={expandedSections.company}
              sx={{
                display: "none",
                "@media (max-width: 856px)": {
                  display: "block",
                },
              }}
            >
              <Box
                sx={{ display: "flex", flexDirection: "column", gap: 1, pt: 1 }}
              >
                <Typography
                  sx={{
                    fontSize: "14px",
                    color: "#666",
                    cursor: "pointer",
                    "&:hover": { color: "#EF5658" },
                  }}
                  onClick={() => handleNavigation("/about")}
                >
                  About Us
                </Typography>
                <Typography
                  sx={{
                    fontSize: "14px",
                    color: "#666",
                    cursor: "pointer",
                    "&:hover": { color: "#EF5658" },
                  }}
                  onClick={() => handleNavigation("/how-r3play-works")}
                >
                  How R3PLAY Works
                </Typography>
                <Typography
                  sx={{
                    fontSize: "14px",
                    color: "#666",
                    cursor: "pointer",
                    "&:hover": { color: "#EF5658" },
                  }}
                  onClick={() => handleNavigation("/contact")}
                >
                  Contact Us
                </Typography>
              </Box>
            </Collapse>
          </Box>

          {/* Our Mission */}
          <Box
            sx={{
              flex: "1 1 25%",
              minWidth: 0,
              "@media (max-width: 1360px) and (min-width: 857px)": {
                display: "none",
              },
              "@media (max-width: 856px)": {
                width: "100%",
                mb: 1,
              },
            }}
          >
            <Box
              component="img"
              src={logo}
              alt="R3PLAY Logo"
              sx={{
                width: "174px",
                height: "auto",
                mb: 1,
                "@media (max-width: 856px)": {
                  mt: 1,
                },
              }}
            />
            <Typography
              sx={{
                fontSize: "14px",
                color: "#666",
                lineHeight: 1.5,
              }}
            >
              Our mission is to give toys a second life, reduce waste, and bring
              joy to new homes. We connect toy lovers through buying, selling,
              and sharing the stories behind every pre-loved toy.
            </Typography>
          </Box>
        </Box>

        {/* Second Row for Tablet Only - Company & Our Mission */}
        <Box
          sx={{
            display: "none",
            "@media (max-width: 1360px) and (min-width: 857px)": {
              display: "flex",
              justifyContent: "space-between",
              gap: 4,
            },
          }}
        >
          {/* Company - Tablet Only */}
          <Box sx={{ flex: 1 }}>
            <Typography
              sx={{
                fontSize: "16px",
                fontWeight: "bold",
                color: "#333",
                mb: 1,
                textTransform: "uppercase",
              }}
            >
              COMPANY
            </Typography>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
              <Typography
                sx={{
                  fontSize: "14px",
                  color: "#666",
                  cursor: "pointer",
                  "&:hover": { color: "#EF5658" },
                }}
                onClick={() => handleNavigation("/about")}
              >
                About Us
              </Typography>
              <Typography
                sx={{
                  fontSize: "14px",
                  color: "#666",
                  cursor: "pointer",
                  "&:hover": { color: "#EF5658" },
                }}
                onClick={() => handleNavigation("/how-r3play-works")}
              >
                How R3PLAY Works
              </Typography>
              <Typography
                sx={{
                  fontSize: "14px",
                  color: "#666",
                  cursor: "pointer",
                  "&:hover": { color: "#EF5658" },
                }}
                onClick={() => handleNavigation("/contact")}
              >
                Contact Us
              </Typography>
            </Box>
          </Box>

          {/* Our Mission - Tablet Only */}
          <Box sx={{ flex: 1 }}>
            <Box
              component="img"
              src={logo}
              alt="R3PLAY Logo"
              sx={{
                width: "174px",
                height: "auto",
                mb: 1,
              }}
            />
            <Typography
              sx={{
                fontSize: "14px",
                color: "#666",
                lineHeight: 1.5,
              }}
            >
              Our mission is to give toys a second life, reduce waste, and bring
              joy to new homes. We connect toy lovers through buying, selling,
              and sharing the stories behind every pre-loved toy.
            </Typography>
          </Box>
        </Box>
      </Box>

      {/* Bottom Section */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          borderTop: "1px solid #E0E0E0",
          pt: 2,
          "@media (max-width: 856px)": {
            flexDirection: "column",
            alignItems: "flex-start",
            gap: 2,
          },
        }}
      >
        <Box>
          <Typography
            sx={{
              fontSize: "14px",
              color: "#999",
              mb: 0.5,
            }}
          >
            © 2025 R3PLAY LLC
          </Typography>
          <Typography
            sx={{
              fontSize: "14px",
              color: "#999",
            }}
          >
            All rights reserved
          </Typography>
        </Box>

        <Box
          sx={{
            display: "flex",
            gap: 3,
            "@media (max-width: 856px)": {
              gap: 4,
              pt: 1,
            },
          }}
        >
          <Typography
            sx={{
              fontSize: "14px",
              color: "#666",
              cursor: "pointer",
              "&:hover": { color: "#EF5658" },
            }}
            onClick={() => handleNavigation("/privacy-policy")}
          >
            Privacy Policy
          </Typography>
          <Typography
            sx={{
              fontSize: "14px",
              color: "#666",
              cursor: "pointer",
              "&:hover": { color: "#EF5658" },
            }}
            onClick={() => handleNavigation("/terms-of-use")}
          >
            Terms of Service
          </Typography>
          <Typography
            sx={{
              fontSize: "14px",
              color: "#666",
              cursor: "pointer",
              "&:hover": { color: "#EF5658" },
            }}
            onClick={() => handleNavigation("/cookie-policy")}
          >
            Cookie Policy
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default Footer;
